<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'write-off' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('writeOff.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('writeOff.pageTitle'),
            href: '/transfer-by-serials'
          },
          {
            text: $t('writeOff.showDetail'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="waiting">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('writeOff.writeOffInfo') }}
                    </legend>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.writeOffNumber') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{ edit_data.write_off_number }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.date') }}
                        :
                      </div>
                      <div class="col-md-3">{{ edit_data.write_off_date }}</div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.confirmedBy') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.confirmed_by
                            ? edit_data.confirmed_by.employee
                              ? edit_data.confirmed_by.employee.employee_name_en
                              : ''
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.confirmedDate') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{ edit_data.confirmed_date }}
                      </div>
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.isConfirm') }} :
                      </div>
                      <div class="col-md-3">
                        <span
                          class="badge badge-success"
                          v-if="edit_data.is_confirm"
                          >Yes</span
                        >
                        <span class="badge badge-danger" v-else>No</span>
                      </div>
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('writeOff.writeOffDetail') }}
                    </legend>
                    <div class="overflow-auto max-h">
                      <ts-table :columns="columns" :records="datasource">
                        <template v-slot="{ record }">
                          <td class="text-nowrap">
                            {{ record.product ? record.product.barcode : '' }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product
                                ? record.product.pro_group_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product
                                ? record.product.product_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{
                              record.unit_of_measure
                                ? record.unit_of_measure.uom_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.quantity }}
                          </td>
                          <td class="text-center text-nowrap">
                            <a
                              href="#"
                              v-if="record.write_off_detail_serial.length > 0"
                              v-tooltip="$t('writeOff.serial')"
                              class="text-info"
                              @click.prevent="serial(record)"
                            >
                              <i class="fas fa-align-justify"></i>
                            </a>
                          </td>
                        </template>
                      </ts-table>
                    </div>
                    <div class="ts-mt-1 ts-text-right ts-font-bold text-danger">
                      TOTAL : {{ total }}
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ShowSerials from './components/show-serial'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })
export default {
  name: 'previewDetail',
  data () {
    return {
      waiting: false,
      show_serial: false,
      status_id: 1,
      datasource: []
    }
  },
  computed: {
    ...mapState('stock/writeOff', ['edit_data']),
    total () {
      return _.sumBy(this.datasource, function (el) {
        return el.quantity
      })
    },
    columns () {
      return [
        { name: this.$t('writeOff.barcode') },
        { name: this.$t('writeOff.group') },
        { name: this.$t('writeOff.product') },
        { name: this.$t('writeOff.uom'), style: 'text-align:center' },
        { name: this.$t('writeOff.quantity'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px' }
      ]
    }
  },
  created () {
    this.setDetails()
  },
  methods: {
    setDetails () {
      this.datasource = this.edit_data.write_off_details
    },
    format_number (value) {
      return parseFloat(value).toFixed(2)
    },
    serial (item) {
      this.$modal.show(
        ShowSerials,
        {
          data: item
        },
        {
          height: 'auto',
          width: '600px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
.max-h {
  max-height: 50vh;
}
fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>
